import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonList,
  IonButtons,
  IonButton,
  IonGrid,
  IonCol,
  IonRow,
  IonLabel,
  IonBackButton,
  IonImg,
  IonModal,
  IonSlides,
  IonSlide,
  withIonLifeCycle,
  isPlatform,
  IonPopover,
  IonInput,
  IonText,
} from "@ionic/react";

import { RouteComponentProps, withRouter } from "react-router";
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

import { TextToSpeech, TTSOptions } from "@capacitor-community/text-to-speech";

import { format } from "date-fns";

// CSS
import "./ClinicalNoticePage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import buttonClose from "../../assets/Button_Close@3x.png";
import iconAccessibility from "../../assets/Button_Accessibility@3x.png";
import iconBookmarkActive from "../../assets/Button_Bookmark_2Active@3x.png";
import iconBookmarkInactive from "../../assets/Button_Bookmark_1Inactive@3x.png";
import iconPlayWhite from "../../assets/Button_Audio_Play_White@3x.png";
import iconStop from "../../assets/Button_Audio_Stop@3x.png";
import iconSearchInactive from "../../assets/Button_Page Search_1 Default@3x.png";
import iconSearchActive from "../../assets/Button_Page Search_2 Active@3x.png";
import iconSearch from "../../assets/Button_Search_Small@3x.png";
import iconSearchDark from "../../assets/Button_Search_Small_Dark@3x.png";
import buttonDown from "../../assets/Button_Disclosure_Down@3x.png";
import buttonUp from "../../assets/Button_Disclosure_Up@3x.png";
import iconMinus from "../../assets/Button_Expand_Minus@3x.png";
import iconMinusDark from "../../assets/Button_Expand_Minus_Dark@3x.png";

// Controllers
import { IScreenProps, IUser, IGuideline, IAlgorithm, IGuidelineSummary, IClinicalNotice } from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components
import _ from "lodash";
import FontPopover from "../../components/FontPopover";
import ImageViewerModal from "../../components/ImageViewerModal";

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  selectedID: number;
  clinicalNotice: IClinicalNotice | undefined;
  acknowledged: boolean;
  imageModalVisible: boolean;
  fontModalVisible: boolean;
  fontModalEvent: any;
  imageSrc: any;
  remainingTextToSpeechText: string;
  showSearch: boolean;
  searchText: string;
  searchIndex: number;
  searchOccurences: number;
};

class ClinicalNoticePage extends Component<Props, State> {
  private imageModalZoom: React.RefObject<ReactZoomPanPinchRef>;
  private searchTextField: React.RefObject<HTMLIonInputElement>;

  constructor(props: Props) {
    super(props);

    this.imageModalZoom = React.createRef();
    this.searchTextField = React.createRef();

    let selectedIDString = "";
    if (props.match.url != null) {
      selectedIDString = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }
    if (selectedIDString == null) {
      selectedIDString = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }

    let selectedID = parseInt(selectedIDString);

    let clinicalNotice = this.props.screenProps.clinicalNotices.find(
      (_clinicalNotice) => _clinicalNotice.ID === selectedID
    );

    let acknowledged = false;

    if (clinicalNotice != null) {
      acknowledged = DataController.isCNAcknowledged(clinicalNotice, this.props.screenProps.clinicalNoticeAcks);
    }

    this.state = {
      selectedID,
      clinicalNotice,
      acknowledged,
      imageModalVisible: false,
      fontModalVisible: false,
      fontModalEvent: null,
      imageSrc: "",
      remainingTextToSpeechText: "",
      showSearch: false,
      searchText: "",
      searchIndex: 0,
      searchOccurences: 0,
    };
  }

  async componentDidMount() {
    document.addEventListener("click", this.handleClickEvent);

    if (this.state.clinicalNotice != null && this.props.screenProps.user != null) {
      RemoteDataController.logUsage(
        null,
        null,
        this.state.clinicalNotice,
        null,
        null,
        false,
        "",
        this.props.screenProps.user,
        this.props.screenProps.app
      );
      await this.props.screenProps.saveRecentlyViewed("", null, this.state.clinicalNotice.ID, null, "clinical notice");
    }

    if (this.props.location && this.props.location.state != null) {
      let locationState: any = this.props.location.state;
      if (locationState.searchTerm && locationState.searchTerm !== "") {
        this.toggleSearch(false);
        setTimeout(() => {
          this.searchValueChanged(locationState.searchTerm);
        }, 500);
      }
    }
  }

  ionViewWillLeave() {
    // back.remove();
    this.stopReading();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickEvent);
  }

  async componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      prevProps.screenProps.clinicalNotices != this.props.screenProps.clinicalNotices ||
      prevProps.screenProps.clinicalNoticeAcks != this.props.screenProps.clinicalNoticeAcks
    ) {
      let clinicalNotice = this.props.screenProps.clinicalNotices.find(
        (clinicalNotice) => clinicalNotice.ID === this.state.selectedID
      );

      if (clinicalNotice != null) {
        let acknowledged = DataController.isCNAcknowledged(clinicalNotice, this.props.screenProps.clinicalNoticeAcks);
        this.setState({ clinicalNotice, acknowledged });
      }
    }

    if (this.state.searchText !== prevState.searchText && this.state.searchText.length > 0) {
      this.highlightFirst();
    }
  }

  highlightFirst() {
    let content;
    let tab = this.props.match.params.tab;
    let highlighted;
    let selected;

    if (tab === "dashboard") {
      content = document.getElementById("dashboard-guideline-content");
    } else if (tab === "guidelines") {
      content = document.getElementById("guidelines-guideline-content");
    } else if (tab === "meds") {
      content = document.getElementById("meds-guideline-content");
    } else if (tab === "pageforage") {
      content = document.getElementById("pageforage-guideline-content");
    }

    if (content !== null && content !== undefined) {
      highlighted = content.getElementsByClassName("searchHighlight");
      selected = content.getElementsByClassName("searchHighlightCurrent");
    }

    if (highlighted !== undefined && selected !== undefined && highlighted.length > 0) {
      if (selected.length === 0) {
        highlighted[0].className = "searchHighlight searchHighlightCurrent";
        this.scrollToHighlight(highlighted[0], "center");
      }
    }
  }

  toggleSearch(focusKeyboard: boolean) {
    this.setState({
      showSearch: !this.state.showSearch,
      searchText: "",
    });

    // if about to show search - focus keyboard if requested
    if (!this.state.showSearch && focusKeyboard) {
      setTimeout(() => {
        if (this.searchTextField.current) {
          this.searchTextField.current.setFocus();
        }
      }, 200);
    }
  }

  enterButtonClicked(event: any) {
    if (event.key === "Enter") {
      this.nextOccurence();
    }
  }

  clearSearch() {
    this.searchTextField.current?.setFocus();
    this.setState({ searchText: "" });
  }

  textIndexToHTMLIndex(startIndex: number, endIndex: number, innerText: string, innerHTML: string) {
    var stringToSearch = innerText.substring(startIndex, endIndex);
    var occurInInnerText = this.getIndicesOf(stringToSearch, innerText, true);
    var whichOccurence = occurInInnerText.indexOf(startIndex);
    var stringToSearchInHTML = stringToSearch
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/\n/g, "<br>");
    var occurencesInHTML = [];
    var isChecking = true;
    for (var i = 0; i < innerHTML.length; i++) {
      if (stringToSearchInHTML == stringToSearch) {
        if (innerHTML.charAt(i) == "<" || innerHTML.charAt(i) == "&") {
          isChecking = false;
        } else if (innerHTML.charAt(i - 1) == ">" || innerHTML.charAt(i - 1) == ";") {
          isChecking = true;
        }
      } else {
        if (innerHTML.charAt(i) == "<") {
          isChecking = false;
        } else if (innerHTML.charAt(i - 1) == ">") {
          isChecking = true;
        }
      }
      if (isChecking) {
        if (innerHTML.substring(i, i + stringToSearchInHTML.length) == stringToSearchInHTML) {
          occurencesInHTML.push(i);
        }
      }
    }
    let startIndexInHTML = occurencesInHTML[whichOccurence];
    let endIndexInHTML = startIndexInHTML + stringToSearchInHTML.length;
    return [startIndexInHTML, endIndexInHTML];
  }

  getIndicesOf(searchStr: string, str: string, caseSensitive: boolean) {
    var searchStrLen = searchStr.length;
    if (searchStrLen == 0) {
      return [];
    }
    var startIndex = 0,
      index,
      indices = [];
    if (!caseSensitive) {
      str = str.toLowerCase();
      searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
      indices.push(index);
      startIndex = index + searchStrLen;
    }
    return indices;
  }

  searchValueChanged(searchText: string) {
    let value = searchText
      .toLowerCase()
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\{/g, "\\{")
      .replace(/\}/g, "\\}")
      .replace(/\./g, "\\.");

    let content;
    let tab = this.props.match.params.tab;

    if (tab === "dashboard") {
      content = document.getElementById("dashboard-guideline-content");
    } else if (tab === "guidelines") {
      content = document.getElementById("guidelines-guideline-content");
    } else if (tab === "meds") {
      content = document.getElementById("meds-guideline-content");
    } else if (tab === "pageforage") {
      content = document.getElementById("pageforage-guideline-content");
    }

    let text: string | null = null;

    if (content !== null && content !== undefined) {
      text = content.textContent;
    }

    this.setState({
      searchText: searchText,
    });

    try {
      // const regex = new RegExp(value, 'gi');
      // const result = [];

      // if ((text !== null && text !== undefined) && value.length > 1) {
      //   text = text.replace('Showing for age: All AllAdult18+16 to 1812 to AdultChild12 to 16 years11 years10 years9 years8 years7 years6 years5 years4 years3 years2 years18 monthsInfant12 months9 months6 months3 months1 monthBirth', '')

      //   while (regex.exec(text.toLowerCase())) {
      //     result.push(regex);
      //   }
      // }

      setTimeout(() => {
        let occurencesLength = 0;

        let content = null;
        let tab = this.props.match.params.tab;
        if (tab === "dashboard") {
          content = document.getElementById("dashboard-guideline-content");
        } else if (tab === "guidelines") {
          content = document.getElementById("guidelines-guideline-content");
        } else if (tab === "meds") {
          content = document.getElementById("meds-guideline-content");
        } else if (tab === "pageforage") {
          content = document.getElementById("pageforage-guideline-content");
        }

        if (content !== null && content !== undefined) {
          occurencesLength = content.getElementsByClassName("searchHighlight").length;
        }

        if (occurencesLength > 0 && text !== null) {
          this.setState({
            searchIndex: 1,
            searchOccurences: occurencesLength,
          });
        } else {
          this.setState({
            searchIndex: 0,
            searchOccurences: 0,
          });
        }
      }, 100);
    } catch (error) {
      this.setState({
        searchIndex: 0,
        searchOccurences: 0,
        searchText: searchText,
      });
      console.log(error);
    }
  }

  nextOccurence() {
    const searchBarIndex = this.state.searchIndex;

    if (searchBarIndex !== 0) {
      let content;
      let tab = this.props.match.params.tab;
      let occurences: any;

      if (tab === "dashboard") {
        content = document.getElementById("dashboard-guideline-content");
      } else if (tab === "guidelines") {
        content = document.getElementById("guidelines-guideline-content");
      } else if (tab === "meds") {
        content = document.getElementById("meds-guideline-content");
      } else if (tab === "pageforage") {
        content = document.getElementById("pageforage-guideline-content");
      }

      if (content !== null && content !== undefined) {
        occurences = content.getElementsByClassName("searchHighlight");
      }

      if (searchBarIndex === occurences.length) {
        occurences[0].className = "searchHighlight searchHighlightCurrent";
        occurences[occurences.length - 1].className = "searchHighlight";

        this.scrollToHighlight(occurences[0], "center");

        this.setState({
          searchIndex: 1,
        });
      } else {
        try {
          occurences[searchBarIndex].className = "searchHighlight searchHighlightCurrent";
          occurences[searchBarIndex - 1].className = "searchHighlight";

          this.scrollToHighlight(occurences[searchBarIndex], "center");

          this.setState({
            searchIndex: searchBarIndex + 1,
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  previousOccurence() {
    const searchBarIndex = this.state.searchIndex;

    if (searchBarIndex !== 0) {
      let content;
      let tab = this.props.match.params.tab;
      let occurences: any;

      if (tab === "dashboard") {
        content = document.getElementById("dashboard-guideline-content");
      } else if (tab === "guidelines") {
        content = document.getElementById("guidelines-guideline-content");
      } else if (tab === "meds") {
        content = document.getElementById("meds-guideline-content");
      } else if (tab === "pageforage") {
        content = document.getElementById("pageforage-guideline-content");
      }

      if (content !== null && content !== undefined) {
        occurences = content.getElementsByClassName("searchHighlight");
      }

      if (searchBarIndex === 1 && occurences.length > 0) {
        occurences[occurences.length - 1].className = "searchHighlight searchHighlightCurrent";
        occurences[0].className = "searchHighlight";

        this.scrollToHighlight(occurences[occurences.length - 1], "center");

        this.setState({
          searchIndex: occurences.length,
        });
      } else {
        occurences[searchBarIndex - 2].className = "searchHighlight searchHighlightCurrent";
        occurences[searchBarIndex - 1].className = "searchHighlight";

        this.scrollToHighlight(occurences[searchBarIndex - 2], "center");

        this.setState({
          searchIndex: searchBarIndex - 1,
        });
      }
    }
  }

  scrollToHighlight(element: any, block: "start" | "center" | "end") {
    try {
      let parent = element.parentElement;
      let cardFound = false;

      while (parent !== null || !cardFound) {
        if (parent.id.includes("content-")) {
          let content: HTMLElement = document.getElementById(`${parent.id}`) as HTMLElement;
          let icon: HTMLImageElement = document.getElementById(`${parent.id}-icon`) as HTMLImageElement;

          if (content !== null && icon !== null) {
            if (content.hidden) {
              content.hidden = false;
              icon.src = this.props.screenProps.darkMode ? iconMinusDark : iconMinus;
            }
          }

          cardFound = true;
        }

        parent = parent.parentElement;
      }
    } catch (error) {
      console.log(error);
    }

    element.scrollIntoView({ behavior: "smooth", block: block });
  }

  count(stringToSearch: string, stringToFind: string) {
    return stringToSearch.split(stringToFind).length - 1;
  }

  handleClickEvent = (event: any) => {
    if (event.srcElement.className.includes("searchHighlight")) {
      if (event.srcElement.parentElement) {
        event.srcElement.parentElement.click();
        return;
      }
    }

    if (this.state.clinicalNotice != null) {
      if (event.srcElement.localName === "link" || event.srcElement.localName === "a") {
        console.log(true, event.srcElement);
        if (this.props.match.url === event.currentTarget.location.pathname) {
          console.log(event.srcElement);

          let href = DataController.stripLocalLinks(event.srcElement.href);
          console.log(href);

          if (
            event.srcElement.href.includes("jrcalcplusweb.co.uk") ||
            event.srcElement.href.includes("responderplus.co.uk")
          ) {
            // link is internal so push it
            this.props.history.push("/" + href);
          } else {
            // link is external so navigate to it
            window.open(event.srcElement.href, "_blank");
            let link = document.createElement("a");
            link.setAttribute("href", href);
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener");
            link.click();
          }

          event.preventDefault();
          event.stopPropagation();
        }
      }

      if (event.srcElement.localName === "link-cm") {
        if (this.props.match.url === event.currentTarget.location.pathname) {
          const GLID = event.srcElement.attributes.glid.value;
          const title = event.srcElement.textContent;

          this.goToGuideline(GLID, null, title);
        }
      }

      if (event.srcElement.localName === "cm-link") {
        if (this.props.match.url === event.currentTarget.location.pathname) {
          if (event.srcElement && event.srcElement.attributes && event.srcElement.attributes.length > 0) {
            let href = event.srcElement.attributes[0];
            if (href.value != null && href.value.includes("CLID")) {
              let GLID = href.value.substr(5);
              let title = event.srcElement.textContent;

              this.goToGuideline(GLID, null, title);
            }
          }
        }
      }

      if (
        event.srcElement.localName === "img" &&
        event.srcElement.className.includes("icon-44") === false &&
        event.srcElement.className.includes("icon-toggle") === false
      ) {
        console.log(event);
        // if (event.srcElement.className === "noticeImage" ||
        // event.srcElement.className === "noticeImage noticeImageMobile") {
        if (this.props.match.url === event.currentTarget.location.pathname) {
          console.log(event);
          RemoteDataController.logEvent("image_modal_clicked", {
            from: "clinical_notice",
            clinicalNoticeID: this.state.clinicalNotice.ID,
          });
          this.toggleImageModal(true, event.srcElement);
        }
        // }
      }
    }
  };

  handleBackEvent = (event: any) => {
    if (this.state.imageModalVisible) {
      this.setState({
        imageModalVisible: false,
      });
    } else if (this.state.fontModalVisible) {
      this.setState({
        fontModalVisible: false,
      });
    } else {
      // console.log(event);
    }
  };

  async goToGuideline(GLID: string, id: string | null, title: string) {
    try {
      let guidelineSummaries: IGuidelineSummary[] = this.props.screenProps.guidelineSummaries;
      let index = guidelineSummaries.findIndex((guidelineSummary) => guidelineSummary.GLID === GLID);
      let content: any = document.getElementsByTagName("ion-tab-bar")[0];

      if (index !== -1) {
        let guidelineSummary = guidelineSummaries[index];

        this.props.screenProps.updateGuidelineLastOpenedVersion(guidelineSummary);

        this.props.screenProps.navigateToGuideline(
          GLID,
          this.props.match.params.tab,
          this.props.history,
          null,
          "Guideline"
        );
      } else {
        // this.setAlertVisible(true, { GLID, title });
      }
    } catch (error) {
      console.log(error);
    }
  }

  generateNotice(clinicalNotice: IClinicalNotice) {
    let title = clinicalNotice.Title;

    let regions = "";
    let pgdPermissions = "";
    if (clinicalNotice.regions != null && clinicalNotice.regions !== "") {
      title = "Regional: " + title;
      regions = clinicalNotice.regions.split(",").join(", ");
    }
    if (clinicalNotice["pgd permissions"] != null && clinicalNotice["pgd permissions"] !== "") {
      pgdPermissions = clinicalNotice["pgd permissions"].split(",").join(", ");
    }

    let html = clinicalNotice.content_container;
    // console.log(html);

    // all tables should now scroll if needed - so replace previously used table1 tag with table
    html = html.replace(/table1/g, "table");

    if (html.includes("<table")) {
      // html = this.generateTable(html);
      html = html.replace(
        /<table/g,
        '<div scrollbar-x="false" scrollbar-y="false" style="overflow: auto; padding-bottom: 10px; overflow-y: hidden;"><table'
      );
      html = html.replace(/<\/table>/g, "</table></div>");
    }

    if (isPlatform("mobile") && !isPlatform("tablet")) {
      html = html.replace(/<img alt/g, '<img class="noticeImage noticeImageMobile" alt');
    } else {
      html = html.replace(/<img alt/g, '<img class="noticeImage" alt');
    }

    // some clinical notices have an h1 tag with a margin-left of -20px, which is causing the text to go off the screen
    html = html.replace("margin-left:-20px", "margin-left:0px");

    let updatedDate = new Date(clinicalNotice.updated);
    let updatedDateShortString = format(updatedDate, "do MMMM, yyyy");
    let updatedDateLongString = format(updatedDate, "do MMMM, yyyy");

    // html = '<a href="cpgcpd://quiz/ABDEEAST">Link text</a>' + html;

    if (isPlatform("desktop") || isPlatform("mobileweb")) {
      html = html.replace(/cpgcpd:\/\/quiz\//g, "https://parapassweb.co.uk/?quiz=");
    }

    if (this.state.searchText.length > 1) {
      let indexOfEndOfStyle = html.indexOf("</style>") + 8;
      let style = html.substring(0, indexOfEndOfStyle);
      let htmlContent = html.substring(indexOfEndOfStyle);
      html = style + DataController.addHighlight(htmlContent, this.state.searchText);
    }

    return (
      <div className="noticeBody">
        {clinicalNotice.updated ? (
          <div style={{ fontSize: this.fontSize(16) }} className="clinicalNoticeDate">
            {updatedDateShortString}
          </div>
        ) : null}
        <div style={{ fontSize: this.fontSize(22), lineHeight: this.fontSize(22) + 8 }} className="clinicalNoticeTitle">
          {title}
        </div>
        {regions !== "" ? (
          <div
            style={{ fontSize: this.fontSize(15), lineHeight: this.fontSize(15) + 8 }}
            className="clinicalNoticeRegionsTitle"
          >
            Regions
            <div
              style={{ fontSize: this.fontSize(20), lineHeight: this.fontSize(20) + 8 }}
              className="clinicalNoticeRegions"
            >
              {regions}
            </div>
          </div>
        ) : null}
        {pgdPermissions !== "" ? (
          <div
            style={{ fontSize: this.fontSize(15), lineHeight: this.fontSize(15) + 8 }}
            className="clinicalNoticeRegionsTitle"
          >
            PGD Permissions
            <div
              style={{ fontSize: this.fontSize(20), lineHeight: this.fontSize(20) + 8 }}
              className="clinicalNoticeRegions"
            >
              {pgdPermissions}
            </div>
          </div>
        ) : null}
        <div
          style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
        {clinicalNotice.updated ? (
          <div style={{ fontSize: this.fontSize(15) }} className="clinicalNoticeUpdatedDate">
            {`Updated Date: ${updatedDateLongString}`}
          </div>
        ) : null}

        {clinicalNotice.informationOnly !== true && clinicalNotice.localClinicalUpdate !== true ? (
          <>
            {this.state.acknowledged ? (
              <div className="clinicalNoticeAcknowledgedContainer">
                <div className="clinicalNoticeAcknowledgedText">Acknowledged</div>
              </div>
            ) : (
              <>
                {this.props.screenProps.user &&
                this.props.screenProps.user.isTemporary !== true &&
                this.props.screenProps.user.uid != null ? (
                  <IonButton
                    className="clinicalNoticeAcknowledgeButton filledButton"
                    onClick={this.acknowledgeButtonClicked.bind(this)}
                  >
                    Acknowledge
                  </IonButton>
                ) : null}
              </>
            )}
          </>
        ) : null}
      </div>
    );
  }

  bookmarkButtonPressed() {
    if (this.state.clinicalNotice != null) {
      this.props.screenProps.saveBookmark("", null, this.state.clinicalNotice.ID, null, "clinical notice");
    }
  }

  isBookmarked() {
    if (this.state.clinicalNotice) {
      let bookmark = _.find(this.props.screenProps.bookmarks, {
        clinicalNoticeID: this.state.clinicalNotice.ID,
        type: "clinical notice",
      });
      return bookmark != null;
    } else {
      return false;
    }
  }

  toggleFontModal(value: boolean, event: any) {
    this.setState({
      fontModalVisible: value,
      fontModalEvent: event,
    });
    if (value === true) {
      RemoteDataController.logEvent("accessability_popover_opened", {
        from: "clinical notice",
      });
    }
  }

  toggleImageModal(value: boolean, srcElement?: any) {
    this.props.screenProps.showStatusBar(value, "#008477");

    if (srcElement) {
      let html = srcElement.outerHTML
        .replace('class="algorithmImage"', "")
        .replace('class="algorithmImage algorithmImageMobile"', "");

      this.setState({
        imageSrc: html,
        imageModalVisible: value,
      });
    } else {
      this.setState({
        imageModalVisible: value,
      });
    }
  }

  fontSize(size: number) {
    return `${size + this.props.screenProps.fontSizeChange}px`;
  }

  async readClinicalNotice() {
    try {
      await this.stopReading();
      await DataController.waitForMilliseconds(500);

      let content: HTMLElement | null = null;

      let tab = this.props.match.params.tab;

      if (tab === "dashboard") {
        content = document.getElementById("dashboard-guideline-content");
      } else if (tab === "guidelines") {
        content = document.getElementById("guidelines-guideline-content");
      } else if (tab === "meds") {
        content = document.getElementById("meds-guideline-content");
      }

      let text: string = "";

      if (content != null && content.innerText != null) {
        text = content.innerText;
        text = text.replace(/\n/g, ". ");
        text = text.replace(/\.\./g, ".");
        text = text.replace(/Play section/g, "");
        if (text.startsWith(". ")) {
          text = text.slice(2); // remove leading period space
        }

        let supportedLanguages = await TextToSpeech.getSupportedLanguages();

        if (supportedLanguages.languages.length > 0) {
          let remainingText = text + "";
          await this.setStateAsync({ remainingTextToSpeechText: remainingText });

          while (this.state.remainingTextToSpeechText.length > 0) {
            let text = this.state.remainingTextToSpeechText.substring(0, 3000);

            remainingText = this.state.remainingTextToSpeechText.substring(3000);

            await this.setStateAsync({ remainingTextToSpeechText: remainingText });

            let speechSpeed = DataController.convertTextToSpeechSpeed(this.props.screenProps.textToSpeechSpeed);

            let textToSpeechProperties: TTSOptions = {
              text: text,
              rate: speechSpeed,
              pitch: 1.0,
              volume: 1.0,
              category: "playback",
            };

            if (supportedLanguages.languages.includes("en-GB")) {
              textToSpeechProperties.lang = "en-GB";
            }

            await TextToSpeech.speak(textToSpeechProperties);

            if (this.state.clinicalNotice) {
              try {
                RemoteDataController.logEvent("text_spoken", {
                  from: "clinical notice",
                  clinicalNoticeID: this.state.clinicalNotice.ID,
                });
              } catch (error) {}
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async stopReading() {
    await this.setStateAsync({ remainingTextToSpeechText: "" });
    await TextToSpeech.stop();
  }

  acknowledgeButtonClicked() {
    if (this.state.clinicalNotice != null) {
      this.props.screenProps.acknowledgeClinicalNotice(this.state.clinicalNotice);
    }
  }

  setStateAsync(state: any) {
    return new Promise((resolve: any) => {
      this.setState(state, resolve);
    });
  }

  render() {
    let clinicalNotice = this.state.clinicalNotice;

    if (clinicalNotice == null) {
      let messageText = "Clinical Notice is loading";

      if (this.props.screenProps.messageBarText === "") {
        messageText = "Clinical Notice couldn't be loaded. It might not exist or has been removed.";
      }

      return (
        <IonPage>
          <IonHeader>
            <IonToolbar mode="ios" className="navBar">
              <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
                <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div className="emptyPageContainer">
              <div className="emptyPageText">{messageText}</div>
            </div>
          </IonContent>
        </IonPage>
      );
    }

    let content = null;
    let title = clinicalNotice ? clinicalNotice.Title : "";

    content = this.generateNotice(clinicalNotice);
    const isBookmarked = this.isBookmarked();

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonButtons slot="end">
              {this.props.screenProps.showTextToSpeech ? (
                <>
                  <IonButton
                    className="headerButtons audioHeaderButtons"
                    onClick={(event) => this.readClinicalNotice()}
                  >
                    <IonImg src={iconPlayWhite} />
                  </IonButton>
                  <IonButton className="headerButtons audioHeaderButtons" onClick={(event) => this.stopReading()}>
                    <IonImg src={iconStop} />
                  </IonButton>
                </>
              ) : null}
              <IonButton className="headerButtons" onClick={(event) => this.toggleFontModal(true, event)}>
                <IonImg src={iconAccessibility} />
              </IonButton>
              <IonButton className="headerButtons" onClick={() => this.bookmarkButtonPressed()}>
                <IonImg src={isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
              </IonButton>
              <IonButton onClick={this.toggleSearch.bind(this, true)} className="headerButtons">
                <IonImg src={this.state.showSearch ? iconSearchActive : iconSearchInactive} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
          {this.state.showSearch ? (
            <div className="guidelineSearchHeader">
              <IonButton className="searchDoneButton" mode="ios" onClick={this.toggleSearch.bind(this, true)}>
                Done
              </IonButton>
              <div className={`guidelinesSearchInputContainer`}>
                <img alt="" src={this.props.screenProps.darkMode ? iconSearchDark : iconSearch} className="icon-44" />
                <IonInput
                  type="search"
                  value={this.state.searchText}
                  className="searchInputField"
                  placeholder="Search within clinical notice"
                  onIonInput={(event: any) => this.searchValueChanged(event.target.value)}
                  clearOnEdit={false}
                  ref={this.searchTextField}
                  onKeyDown={(event) => this.enterButtonClicked(event)}
                />
                {this.state.searchText !== "" ? (
                  <IonText className="occurences">{`${this.state.searchIndex} of ${this.state.searchOccurences}`}</IonText>
                ) : null}
              </div>
              <IonButton fill="clear" className="searchNextPrevious" onClick={() => this.previousOccurence()}>
                <IonImg className="icon-36" src={buttonUp} />
              </IonButton>
              <IonButton fill="clear" className="searchNextPrevious" onClick={() => this.nextOccurence()}>
                <IonImg className="icon-36" src={buttonDown} />
              </IonButton>
            </div>
          ) : null}
        </IonHeader>
        <IonContent
          color="#EDEEF0"
          id={`${this.props.match.params.tab}-guideline-content`}
          className="clinicalNoticeContent"
        >
          <div className="ACCEGuidelineTitle clinicalNotice" style={{ fontSize: this.fontSize(21) }}>
            <div className="globalContentMargin">CLINICAL NOTICE</div>
          </div>
          <div className="globalContentMargin">
            {content}

            {window.innerWidth < 600 ? (
              <IonModal
                mode="ios"
                id="fontModal2"
                showBackdrop={true}
                isOpen={this.state.fontModalVisible}
                initialBreakpoint={1}
                breakpoints={[0, 1]}
                // event={this.state.fontModalEvent}
                backdropDismiss={true}
                onDidDismiss={() => this.toggleFontModal(false, null)}
              >
                <div className="triangle" />
                <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
              </IonModal>
            ) : (
              <IonPopover
                mode="ios"
                id="fontModal"
                showBackdrop={false}
                isOpen={this.state.fontModalVisible}
                event={this.state.fontModalEvent}
                backdropDismiss={true}
                onDidDismiss={() => this.toggleFontModal(false, null)}
              >
                <div className="triangle" />
                <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
              </IonPopover>
            )}

            <ImageViewerModal
              isOpen={this.state.imageModalVisible}
              isBookmarked={isBookmarked}
              isReferenceCard={false}
              imageSrc={this.state.imageSrc}
              toggleImageModal={this.toggleImageModal.bind(this)}
              bookmarkButtonPressed={this.bookmarkButtonPressed.bind(this)}
              tab={this.props.match.params.tab}
            />
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(ClinicalNoticePage));
